export default __webpack_public_path__ + "static/media/ecology-completed.e59fb17a.png";